/**
 * Lookups de cliente (por teléfono o por número de identificación).
 *
 * Encapsulan el shape de la respuesta del API y devuelven un objeto
 * normalizado, listo para volcar en los campos del formulario.
 */

import { getApi } from 'views/services/api';
import { ID_CARD_TYPES } from '../constants';

const normalizeCustomer = (raw) => {
  if (!raw) return null;
  return {
    phoneNumber: raw.phoneNumber || '',
    firstName: raw.firstName || '',
    lastName: raw.lastName || '',
    email: raw.email || '',
    idCardType: raw.idCardType || ID_CARD_TYPES.DEFAULT,
    idcardNumber: raw.idcardNumber || '',
    address: raw.address || '',
    idFile: raw.idFile || '',
    birthDate: raw.birthDate || '',
    isExternal: Boolean(raw.isExternal)
  };
};

/**
 * Busca un cliente por número de identificación. Devuelve el shape normalizado
 * o null si no existe.
 *
 * @param {string} idCardNumber
 * @param {string} hotelId
 * @returns {Promise<object|null>}
 */
export const lookupCustomerByIdCard = async (idCardNumber, hotelId) => {
  if (!idCardNumber || idCardNumber.length < 5) return null;
  try {
    const response = await getApi(`api/customer/viewById/${idCardNumber}?hotelId=${hotelId}`);
    return normalizeCustomer(response?.data?.customerData?.[0]);
  } catch (err) {
    // El 404 es semánticamente "no existe", no un error de runtime.
    return null;
  }
};

/**
 * Busca un cliente por número de teléfono. Devuelve el shape normalizado
 * o null si no existe.
 *
 * @param {string} phoneNumber
 * @param {string} hotelId
 * @returns {Promise<object|null>}
 */
export const lookupCustomerByPhone = async (phoneNumber, hotelId) => {
  if (!phoneNumber || phoneNumber.length < 10) return null;
  try {
    const response = await getApi(`api/customer/view/${phoneNumber}?hotelId=${hotelId}`);
    return normalizeCustomer(response?.data?.customerData?.[0]);
  } catch (err) {
    return null;
  }
};

/**
 * Convierte una fecha (string ISO o Date) al formato 'YYYY-MM-DD' que
 * espera un input type="date".
 *
 * @param {string|Date} raw
 * @returns {string} '' si la fecha es inválida
 */
export const formatBirthDateForInput = (raw) => {
  if (!raw) return '';
  try {
    return new Date(raw).toISOString().split('T')[0];
  } catch {
    return '';
  }
};
